import { render, staticRenderFns } from "./SettingsSetter.vue?vue&type=template&id=62c79504&"
import script from "./SettingsSetter.vue?vue&type=script&lang=js&"
export * from "./SettingsSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports